// extracted by mini-css-extract-plugin
export default {"burger":"Burger_burger__tP-zJ","close1":"Burger_close1__gZ-1+","close2":"Burger_close2__JJIjP","close3":"Burger_close3__VXFvB"};